export default __webpack_public_path__ + "static/5-86113eeb34ce2867a9032256159f7d40.png";